import settings from "./settings.vue";

export default [
  {
    name: "settings",
    path: "/settings",
    component: settings,
  },
];
